module.exports = __webpack_public_path__ + "img/02.ae5b7b27.png";